import React from 'react'
import { FormattedMessage } from 'react-intl'
import { NavLink } from 'react-router-dom'
import { useCustomer } from 'lib/core/hooks/useCustomer'
import { Container } from './components/Styled'
import { CUSTOMER_SIDEBAR_LINKS } from 'app/sofia/resources/constants'

export const Sidebar = () => {
  const { logout } = useCustomer()

  return (
    <Container>
      <ul>
        {CUSTOMER_SIDEBAR_LINKS.map((sidebarLink, index) => {
          return (
            <li key={index}>
              <NavLink to={sidebarLink.url} activeClassName='selected'>
                {sidebarLink.label}
              </NavLink>
            </li>
          )
        })}
        <li>
          <button onClick={() => logout()}>
            <FormattedMessage id='action.logout' />
          </button>
        </li>
      </ul>
    </Container>
  )
}
